import styled from 'styled-components'

export const CardContainer = styled.div<{ isDarkMode: boolean; pointColor?: string }>`
	width: 420px;
	min-height: 320px;
	// 다크모드: isDarkMode = false, 라이트모드: isDarkMode = true
	background-image: ${props =>
		!props.isDarkMode
			? 'url(/images/card_dark_bg.jpg)' // 다크모드
			: 'url(/images/card_light_bg.jpg)'}; // 라이트모드
	background-size: cover;
	background-position: center;
	background-repeat: no-repeat;
	border-radius: 12px;
	padding: 24px;
	box-shadow: ${props =>
		!props.isDarkMode
			? '0 10px 30px rgba(0, 0, 0, 0.5)' // 다크모드
			: '0 10px 30px rgba(0, 0, 0, 0.1)'}; // 라이트모드
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	position: relative;
	overflow: hidden;
`

export const CardHeader = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: flex-start;
	margin-bottom: 16px;
	z-index: 2;
	position: relative;
`

export const BrandLogo = styled.div<{ isDarkMode?: boolean; pointColor?: string }>`
	display: flex;
	align-items: center;
	gap: 6px;
	font-size: 18px;
	font-weight: 900;
	color: ${props =>
		!props.isDarkMode
			? '#ffffff' // 다크모드 - 흰색
			: '#1a1a1a'}; // 라이트모드 - 검정색
	text-shadow: ${props =>
		!props.isDarkMode
			? '0 2px 8px rgba(255, 255, 255, 0.4), 0 0 20px rgba(255, 255, 255, 0.2)' // 다크모드
			: '0 2px 8px rgba(0, 0, 0, 0.4), 0 0 20px rgba(0, 0, 0, 0.2)'}; // 라이트모드
`

export const UidBadge = styled.div<{ isDarkMode?: boolean }>`
	font-size: 11px;
	font-weight: 700;
	color: ${props =>
		!props.isDarkMode
			? '#fff' // 다크모드
			: '#1e293b'}; // 라이트모드
	background: ${props =>
		!props.isDarkMode
			? 'rgba(255, 255, 255, 0.15)' // 다크모드
			: 'rgba(0, 0, 0, 0.1)'}; // 라이트모드
	padding: 4px 8px;
	border-radius: 6px;
	letter-spacing: 0.3px;
	backdrop-filter: blur(10px);
	border: 1px solid ${props =>
		!props.isDarkMode
			? 'rgba(255, 255, 255, 0.2)' // 다크모드
			: 'rgba(0, 0, 0, 0.15)'}; // 라이트모드
	margin-top: 4px;
`

export const CardBody = styled.div`
	flex: 1;
	z-index: 2;
	position: relative;
	display: flex;
	flex-direction: column;
	justify-content: center;
`

export const ProfitAmount = styled.div<{ isProfit: boolean }>`
	font-size: 34px;
	font-weight: 900;
	color: ${props => (props.isProfit ? '#ef4444' : '#3b82f6')};
	margin-bottom: 4px;
	text-shadow: none;
	letter-spacing: -0.5px;
	text-align: center;
	width: 100%;
	opacity: 1;
`

export const ProfitRate = styled.div<{ isProfit: boolean }>`
	font-size: 16px;
	font-weight: 700;
	color: ${props => (props.isProfit ? '#86efac' : '#fca5a5')};
	margin-bottom: 4px;
`

export const InfoRow = styled.div<{ isDarkMode?: boolean }>`
	display: grid;
	grid-template-columns: 80px auto;
	column-gap: 0;
	align-items: center;
	padding: 8px 0;
`

export const InfoLabel = styled.div<{ isDarkMode?: boolean }>`
	font-size: 16px;
	color: ${props =>
		!props.isDarkMode
			? 'rgba(255, 255, 255, 0.7)' // 다크모드
			: 'rgba(0, 0, 0, 0.6)'}; // 라이트모드
	font-weight: 600;
	text-align: left;
	justify-self: start;
`

export const InfoValue = styled.div<{
	isHighlight?: boolean
	color?: string
	isDarkMode?: boolean
}>`
	font-size: 17px;
	color: ${props =>
		props.isHighlight && props.color
			? props.color
			: !props.isDarkMode
			? '#fff' // 다크모드
			: '#1e293b'}; // 라이트모드
	font-weight: ${props => (props.isHighlight ? '700' : '600')};
	text-align: left;
	justify-self: start;
`

export const TimeStamp = styled.div<{ isDarkMode?: boolean }>`
	font-size: 11px;
	color: ${props =>
		!props.isDarkMode
			? 'rgba(255, 255, 255, 0.7)' // 다크모드
			: 'rgba(0, 0, 0, 0.6)'}; // 라이트모드
	font-weight: 500;
`
